/* Saint Vanity NEW SV — Ajax add-to-cart for the two DTC launch product grids. */
(() => {
  if (window.__svLaunchQuickAddReady) return;
  window.__svLaunchQuickAddReady = true;
  const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
  const cartAddUrl = root + 'cart/add.js';
  const cartUrl = root + 'cart.js';
  document.addEventListener('change', event => {
    const select = event.target.closest('.sv-drop-card-form select[name="id"]');
    if (!select) return;
    const card = select.closest('.ash-editable-collection__card');
    const price = card && card.querySelector('[data-sv-card-price]');
    const chosen = select.selectedOptions && select.selectedOptions[0];
    if (price && chosen && chosen.dataset.price) price.textContent = chosen.dataset.price;
    const feedback = card && card.querySelector('.sv-drop-card-feedback');
    if (feedback) feedback.textContent = '';
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('form.sv-drop-card-form');
    if (!form) return;
    event.preventDefault();
    if (!form.reportValidity()) return;
    const button = form.querySelector('button[type="submit"]');
    if (!button || button.disabled) return;
    const card = form.closest('.ash-editable-collection__card');
    const feedback = card && card.querySelector('.sv-drop-card-feedback');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'ADDING…';
    if (feedback) feedback.textContent = '';
    try {
      const response = await fetch(cartAddUrl, {method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'This item could not be added. Please try again.');
      if (feedback) {
        feedback.textContent = 'ADDED TO CART · ';
        const link = document.createElement('a');
        link.href = root + 'cart';
        link.textContent = 'VIEW CART ↗';
        feedback.appendChild(link);
      }
      const cartResponse = await fetch(cartUrl,{headers:{'Accept':'application/json'}});
      if (cartResponse.ok) {
        const cart = await cartResponse.json();
        const cartLink = document.querySelector('.ash-retail-nav a[href*="/cart"]');
        if (cartLink && Number.isFinite(cart.item_count)) {
          const label = cartLink.dataset.svCartLabel || cartLink.textContent.replace(/\s*\(\d+\)\s*$/,'').trim();
          cartLink.dataset.svCartLabel = label;
          cartLink.textContent = label + ' (' + cart.item_count + ')';
        }
      }
    } catch(err) {
      if (feedback) feedback.textContent = err.message || 'Unable to add. Please try again.';
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = 'ADD TO CART +';
    }
  });
})();
